export { default } from "./Label";



